<template>
  <v-app
    v-on:click="rightClickDisabled"
    @contextmenu.prevent
  >
    <v-progress-linear
      :active="$store.state.loading || $store.state.progressbarActive"
      :indeterminate="$store.state.loading || $store.state.progressbarActive"
      :top="true"
      :height="5"
      :rounded="true"
      :value="0"
      color="indigo darken-2"
    />
    <div
      id="loading"
      v-if="$store.state.loading"
    >
      <div />
    </div>
    <Menu ref="menu" />
    <v-content class="mb-12">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
    <v-footer
      class="bgheader"
      fixed
    >
      <v-row no-gutters>
        <v-col
          cols="10"
          sm="9"
        >
          &nbsp;
        </v-col>
        <v-col
          cols="12"
          sm="3"
          class="d-flex justify-center sm:justify-end"
        >
          <v-img
            contain
            class="ml-4 logoelection"
            max-height="20px"
            src="@/assets/img/logoEleicoes.png"
          />
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Menu from '@/components/Menu.vue';
import { mapState } from 'vuex';
export default {
  components: {
    Menu
  },
  props: {
    source: String
  },
  data: () => ({
    appName: 'Eleições',
    eventListener: {
      backbutton: 'popstate'
    }
  }),
  computed: {
    ...mapState(['appVersion']),
    getCurrentYer() {
      return new Date().getFullYear();
    }
  },
  created() {
    window.addEventListener('contextmenu', event => event.preventDefault());
  },
  mounted() {
    window.addEventListener(this.eventListener.backbutton, this.redirectLogin);
  },
  methods: {
    rightClickDisabled() {
      window.addEventListener('contextmenu', event => event.preventDefault());
    },
    activeMenu() {
      this.$refs.menu.drawer = !this.$refs.menu.drawer;
    },
    redirectLogin() {
      this.$store.state.logout();
    }
  }
};
</script>

<style lang="scss">

footer {
  font-size: 14px;
  min-height: 44px;
}
.candidate_vote {
  max-width: 640px;
}

.candidate-group {
  max-width: 100%;
}

.span-digite-candidato {
  padding: 15px;
  font-size: 20px;
}

.urna_foto {
  padding-left: 116px;
}
.v-input.urna_number {
  width: 100%;
}

.v-input.urna_number > div > div:not(.v-counter) {
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
}
.v-counter {
  margin-top: 8px;
}
.v-input.urna_number input {
  margin: 0;
  padding: 0;
  height: 92px;
  font-size: 82px;
  max-height: 92px !important;
  background: url(assets/img/urna_bg.png);
  width: 400px !important;
  font-weight: 900;
  letter-spacing: 53px;
  padding-left: 20px;
  text-align: left;
  margin: 10px auto -5px auto;
  color: transparent !important;
  text-shadow: 0px 0px 0px #666;
}
.urna_teclado > .teclas {
  width: 100%;
  text-align: center;
}
.urna_teclado > .teclas .v-btn {
  width: 26%;
  font-size: 100%;
  color: #fff !important;
  background: #000;
  position: relative;
  padding-top: 10%;
  min-width: auto !important;
}

.urna_teclado > .teclas .v-btn span {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.v-item--active {
  background-color: #7fc4f3 !important;
  border-style: solid;
  border-width: thick !important;
  border-color: #68b8ee !important;
  color: #000000;
}

.theme--light.v-sheet.login-nopass-alert {
  background: #425e94;
  color: #fff !important;
}
.theme--dark.v-sheet.login-nopass-alert {
  background: #000 !important;
  color: #fff !important;
}

.theme--dark .v-item--active {
  font-weight: bold;
  background-color: #000000 !important;
  border-style: solid;
  border-width: thick !important;
  border-color: #fff !important;
}

.urna_teclado > .teclas_acao {
  text-align: center;
  padding: 0px;
}
.urna_teclado > .teclas_acao .v-btn {
  width: 100%;
  padding: 2rem;
  max-width: 256px;
  min-width: auto !important;
}
.urna_teclado > .teclas_acao .v-btn span {
  position: absolute;
  font-size: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.div-number-information {
  width: 15%;
  background-color: #c8c8c7;
  min-width: auto !important;
  text-align: center;
  margin-left: 1%;
  padding-top: 5%;
  padding-bottom: 5%;
  font-size: 20px;
}
.div-number-information span {
  display: inline-block;
}

.div-minima {
  min-width: 250px !important;
}

.rmv-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

#loading {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: rgba(33, 133, 197, 0.8);
  z-index: 99999;
  padding: 4rem;
  top: 0;
  left: 0;
}

.v-select__selection--comma {
  text-overflow: initial !important;
  white-space: initial !important;
}
.v-list-item__title, .v-list-item__subtitle {
  text-overflow: initial !important;
  white-space: initial !important;
}

.theme--dark .v-stepper__step.v-stepper__step--active .v-stepper__step__step.primary {
  color: #000 !important;
}

.theme--dark .v-stepper__step.v-stepper__step--complete .v-stepper__step__step.primary {
  color: #000 !important;
}

.theme--dark .v-stepper__header .v-stepper__step.v-stepper__step--complete .v-stepper__step__step.primary .v-icon {
  color: #000 !important;
}

.theme--light .v-stepper__step.v-stepper__step--active .v-stepper__step__step.primary {
  color: #fff !important;
}

.theme--light .v-stepper__step.v-stepper__step--complete .v-stepper__step__step.primary {
  color: #fff !important;
}

.theme--light .v-stepper__header .v-stepper__step.v-stepper__step--complete .v-stepper__step__step.primary .v-icon {
  color: #fff !important;
}

.theme--dark.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #fff !important;
  color: #000 !important;
}
.theme--dark .candidate-info {
  color: #fff !important;
}

.v-application .v-stepper__items .v-alert.v-sheet.theme--dark.success {
  color: #000 !important;
}
.v-application .v-stepper__items .v-alert.v-sheet.theme--dark.success .v-icon {
  color: #000 !important;
}

.theme--dark header {
  background-color: #000 !important;
}
header .v-btn--outlined .v-btn__content .v-icon, .v-btn--round .v-btn__content .theme--dark.v-icon {
  color: #000 !important;
}
.v-autocomplete__content.v-menu__content .v-select-list {
  border: #fff 1px solid !important;
}

@media screen and (max-width: 478px) {
  body {
    overflow: clip;
  }
}

#alertWarning > div > div > i {
  color: #000000 !important;
}
</style>
